import { render, staticRenderFns } from "./AppHeaderAddressbook.vue?vue&type=template&id=39022d79"
import script from "./AppHeaderAddressbook.vue?vue&type=script&lang=js"
export * from "./AppHeaderAddressbook.vue?vue&type=script&lang=js"
import style0 from "./AppHeaderAddressbook.vue?vue&type=style&index=0&id=39022d79&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports